import Page from "@/components/layout/Page";

export default function HospitalsHealthcare() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">Hospitals & Healthcare</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Sensory tools designed to support patient wellbeing in healthcare settings.
            </p>
            
            <p className="text-lg leading-relaxed">
              Samboards are used across NHS hospitals and healthcare facilities to support patient wellbeing during treatment, recovery, and rehabilitation. Our sensory products provide calming tactile engagement that can help reduce anxiety during medical procedures and waiting times.
            </p>
            
            <p className="text-lg leading-relaxed">
              In stroke rehabilitation and occupational therapy settings, our sensory pads are used for sensory retraining - helping patients regain sensation and fine motor skills as part of their recovery journey. The different textures provide varied sensory input that supports neurological rehabilitation.
            </p>
            
            <p className="text-lg leading-relaxed">
              Healthcare professionals use our products in mental health units, waiting areas, and patient rooms to provide non-pharmacological support for anxiety and stress management. They're particularly valued for being quiet, portable, and easy to clean - essential qualities in clinical environments.
            </p>
            
            <p className="text-lg leading-relaxed">
              Many NHS trusts have adopted Samboards as part of their approach to patient-centred care, recognising the importance of sensory support in promoting comfort and wellbeing during healthcare experiences.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
